<div class="pos-relative">
    <button
      (click)="onCloseClick()"
      class="pull-right p-r-0-i p-l-s-i"
      mat-button
      color="accent"
      id="bucket-items-duplicate-upload-dialog-btn-close"
    >
      <span
        class="icon-ic-close popup_close"
        id="bucket-items-duplicate-upload-dialog-icon-close"
      ></span>
    </button>
    <h5 class="p-20 m-0 bottomBorderStyle align font-xl p-t-m-i p-l-60-i">
      Some files could not be uploaded
    </h5>
  
    <div class="form-label m-b-s align">
        A file with the same name, extension and checksum already exists. It will not be uploaded as identical files do not need to be kept twice. If the file needs to be uploaded a second time, please rename and upload it again.
    </div>
    <div class="dataMismatchTableContainer">
      <table class="w-100" mat-table [dataSource]="dataSource">
  
        <ng-container matColumnDef="Path and filename">
          <th mat-header-cell *matHeaderCellDef>
            <div class="table-header">
                <div class="w-95">Path and filename</div>
                <div>
                    <button
                      color="accent"
                      mat-button
                      (click)="copyToClipBoard()"
                      id="bucket-items-duplicate-upload-dialog-btn-copy"
                    >
                        <span
                          class="icon-ic-copy"
                          matTooltipClass="tooltip-style"
                          matTooltipPosition="above"
                          matTooltip="Copy list"
                          id="bucket-items-duplicate-upload-dialog-icon-copy"
                        ></span>
                    </button>
                </div>
            </div>
          </th>
          <bdi>
            <td class="cell" mat-cell *matCellDef="let item; let i = index">
              <bdi>
                <span
                  matTooltipClass="tooltip-style"
                  matTooltipPosition="above"
                  matTooltip={{item}}
                  [attr.id]="'bucket-items-duplicate-upload-dialog-lbl-file-' + i"
                >
                  {{item}}
                </span>
              </bdi>
            </td>
          </bdi>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div class="okayButtonContainer">
      <button
        mat-button
        color="primary"
        type="submit"
        class="mat-button"
        (click)="onCloseClick()"
        id="bucket-items-duplicate-upload-dialog-btn-dismiss"
      >
        Close
      </button>
    </div>
  </div>
  
